import { render } from "./DatosUsuarioview.vue?vue&type=template&id=5dab6f40&scoped=true"
import script from "./DatosUsuarioview.vue?vue&type=script&lang=js"
export * from "./DatosUsuarioview.vue?vue&type=script&lang=js"

import "./DatosUsuarioview.vue?vue&type=style&index=0&id=5dab6f40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dab6f40"]])

export default __exports__